import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import Config from "../../../../Config";

import UtilBloc from "../../../../bloc/util_bloc";
import AppSelectButton from "../../../component/app_select_button/app_select_button";
import "./proposal_form.css";

class HealthStatement extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            healthStatementData: {
                isReceivedTreatment: null,
                isContinuouslyReceiveMedication: null,
                isAdvisedMedicalTest: null,
            },
            errorMessage: 'Fill in the required field.',
        };
    }


    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    getFormFields() {
        return this.props.fields;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.healthStatementData;
        formData && Object.keys(formData).map(function (key) {
            stateData[key] = formData[key];
        })
        this.setState({ healthStatementData: stateData })
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    onValidateForm = () => {
        const { healthStatementData } = this.state;
        let validated = true;
        Object.keys(healthStatementData).map(function (key) {
            validated = validated && (!UtilBloc.isNullOrEmpty(healthStatementData[key]) || false);
        });
        this.setPropValidation(validated);
        this.setPropValue();
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    setPropValue = () => {
        let valueobj = this.state.healthStatementData;
        this.props.onChange(valueobj);
    }

    handleValueChange = (field, val) => {
        let data = this.state.healthStatementData;
        data[field] = val
        this.setState({ healthStatementData: data }, () => {
            this.handleIsReceivedTreatment(Object.values(data).indexOf('Yes') > -1);
            this.onValidateForm();
        });
    }

    handleIsReceivedTreatment(val) {
        this.props.handleExtendedFormOpen(val);
    }

    async handleFormSubmit() {

    }

    statementOne() {
        return (
            <AppSelectButton
                // title={Config.proposal.formDataMapping.step1.healthStatementFormTitle.s1}
                value={this.state.healthStatementData.isReceivedTreatment}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isReceivedTreatment, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isReceivedTreatment, 'Yes')}
            />
        )
    }
    statementTwo() {
        return (
            <AppSelectButton
                // title={Config.proposal.formDataMapping.step1.healthStatementFormTitle.s2}
                value={this.state.healthStatementData.isContinuouslyReceiveMedication}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isContinuouslyReceiveMedication, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isContinuouslyReceiveMedication, 'Yes')}
            />
        )
    }
    statementThree() {
        return (
            <AppSelectButton
                // title={Config.proposal.formDataMapping.step1.healthStatementFormTitle.s3}
                value={this.state.healthStatementData.isAdvisedMedicalTest}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isAdvisedMedicalTest, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isAdvisedMedicalTest, 'Yes')}
            />
        )
    }

    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>

                <div className="w-100 px-3 mt-4" >
                    <ol className="p-0">
                        <li className="">
                            {Config.proposal.formDataMapping.step1.healthStatementFormTitle.s1}
                        </li>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                                {this.statementOne()}
                            </div>
                        </div>
                        <li className="mt-4">
                            {Config.proposal.formDataMapping.step1.healthStatementFormTitle.s2}
                        </li>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                                {this.statementTwo()}
                            </div>
                        </div>
                        <li className="mt-4">
                            {Config.proposal.formDataMapping.step1.healthStatementFormTitle.s3}
                        </li>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                                {this.statementThree()}
                            </div>
                        </div>
                    </ol >


                </div >
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(HealthStatement));
